import React from 'react';
import Style from './style.sass'

const Resources = props => {
  const result = props.resources.map((resource, i) => {
    return (
      <tr key={i}>
        <td className={Style.Postal__zipcode}>
          〒{String(resource.code).slice(0, 3) + '-' + String(resource.code).slice(3, resource.code.length)}
        </td>
        <td>
          <p className={Style.Postal__kana}>
            {resource.pref_kana + resource.munic_kana + resource.town_kana}
          </p>
          <p className={Style.Postal__address}>
            {resource.prefecture + resource.municipality + resource.town}
          </p>
        </td>
      </tr>
    )
  });
  return (
    <table className={Style.Postal__table}>
      <tbody>
        { result }
      </tbody>
    </table>
  
  );
};

export default Resources;